const handleSetRadioResponsesPayload = (questionId, choosedResponse, setPayload) => {
    const newData = {
        questionId,
        responseId: choosedResponse
    }

    setPayload((prev) => {
        if (prev?.radiosResponses?.length) {
            const existInArray = prev.radiosResponses.find((item) => item.questionId === questionId)

            if (existInArray) {
                const removeItemFromExistedTem = prev?.radiosResponses?.filter(
                    (item) => item?.questionId !== questionId
                )
                return {
                    ...prev,
                    radiosResponses: [...removeItemFromExistedTem, newData]
                }
            } else {
                return {
                    ...prev,
                    radiosResponses: [...prev.radiosResponses, newData]
                }
            }
        } else {
            return {
                ...prev,
                radiosResponses: [newData]
            }
        }
    })
}

const setCheckBoxValues = ({ questionId, setPayload, checkedIds }) => {
    const newData = {
        questionId,
        responseIds: checkedIds.filter((item) => item !== 0)
    }

    setPayload((prev) => {
        if (prev?.checkboxResponses?.length) {
            const existInArray = prev.checkboxResponses.find((item) => item.questionId === questionId)
            if (existInArray) {
                const removeItemFromExistedTem = prev.checkboxResponses.filter((item) => item.questionId !== questionId)
                return {
                    ...prev,
                    checkboxResponses: [...removeItemFromExistedTem, newData]
                }
            } else {
                return {
                    ...prev,
                    checkboxResponses: [...prev.checkboxResponses, newData]
                }
            }
        } else {
            return {
                ...prev,
                checkboxResponses: [newData]
            }
        }
    })
}

const handleSetCheckBoxResponsesPayload = ({ questionId, responseId, setPayload, setChecked }) =>
    setChecked((prev) => {
        const response = [...prev, responseId]
        if (prev.includes(responseId)) {
            const res = prev.filter((item) => item !== responseId)
            setCheckBoxValues({ questionId, setPayload, checkedIds: res })
            return res
        } else {
            setCheckBoxValues({ questionId, setPayload, checkedIds: response })
            return response
        }
    })

const handleSetTextResponsesPayload = ({ questionId, responseValue, setPayload }) => {
    const newData = {
        questionId,
        response: responseValue
    }

    setPayload((prev) => {
        if (prev?.textResponses?.length) {
            const existInArray = prev.textResponses.find((item) => item.questionId === questionId)
            if (existInArray) {
                const removeItemFromExistedTem = prev.textResponses.filter((item) => item.questionId !== questionId)
                return {
                    ...prev,
                    textResponses: [...removeItemFromExistedTem, newData]
                }
            } else {
                return {
                    ...prev,
                    textResponses: [...prev.textResponses, newData]
                }
            }
        } else {
            return {
                ...prev,
                textResponses: [newData]
            }
        }
    })
}

const setMedicalCheckBoxValues = ({ surveyId, setResponseGlobal, checkedIds, defaultResponse }) => {
    const newData = {
        ...defaultResponse,
        responseIds: checkedIds?.filter((item) => item !== 0)
    }

    setResponseGlobal((prev) => {
        return {
            ...prev,
            [surveyId]: newData
        }
    })
}

const handleSetMedicalCheckBoxResponsesPayload = ({
    defaultResponse,
    surveyId,
    responseId,
    setResponseGlobal,
    setChecked
}) =>
    setChecked((prev) => {
        const response = [...prev, responseId]
        if (prev?.includes(responseId)) {
            const res = prev.filter((item) => item !== responseId)
            setMedicalCheckBoxValues({ defaultResponse, surveyId, setResponseGlobal, checkedIds: res, defaultResponse })
            return res
        } else {
            setMedicalCheckBoxValues({
                defaultResponse,
                surveyId,
                setResponseGlobal,
                checkedIds: response,
                defaultResponse
            })
            return response
        }
    })

const handleSetMedicalCheckBoxRadioResponsesPayload = ({
    defaultResponse,
    surveyId,
    responseId,
    setResponseGlobal,
    setChecked
}) =>
    setChecked(() => {
        const res = [responseId]
        setMedicalCheckBoxValues({
            defaultResponse,
            surveyId,
            setResponseGlobal,
            checkedIds: [responseId],
            defaultResponse
        })
        return res
    })

const ConditionWithNegation = (conditionValue) => {
    const value = conditionValue || ""
    const hasNegation = value?.charAt(0) === "!"
    return hasNegation ?? false
}

export {
    ConditionWithNegation,
    handleSetMedicalCheckBoxRadioResponsesPayload,
    handleSetMedicalCheckBoxResponsesPayload,
    handleSetRadioResponsesPayload,
    handleSetCheckBoxResponsesPayload,
    handleSetTextResponsesPayload
}
